import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Loader from '../../components/Loader';
import Template from './Template';
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';
import { useConnect } from '../../../hooks/@lore/query-connect';

EvaluationProjectEducatorDialog.propTypes = {
  evaluationProjectEducator: PropTypes.object.isRequired
};

export default function EvaluationProjectEducatorDialog(props) {
  const { evaluationProjectEducator } = props;

  const project = useConnect('project.byId', {
    id: evaluationProjectEducator.data.projectId
  });

  if (project.state === PayloadStates.FETCHING) {
    return (
      <DialogTemplate>
        <Loader />
      </DialogTemplate>
    );
  }

  return (
    <DialogTemplate className="w-full max-w-screen-lg">
      <CloseDialogButton onClick={props.onClose} />
      <div className="px-6 pt-16 pb-6">
        <Template
          project={project}
          evaluationProjectEducator={evaluationProjectEducator}
          onClose={props.onClose}
        />
      </div>
    </DialogTemplate>
  );
};
